import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import Tippy from '@tippyjs/react/headless';
import ActionBar from "~/layout/ActionBar";
import {
	Button, Icon, PopperWrapper, Loading, Modal
} from "~/components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {
	serviceToDoApi
} from "~/api";
import {
	serviceToDoActions,
	serviceToDoErrorSelector,
	serviceToDoFilterSelector,
	serviceToDoItemsSelector,
	serviceToDoLoadingSelector,
	serviceToDoPaginationSelector
} from "../serviceToDoSlice";
import {
	ServiceToDoTable,
	ToDoFormAddDomain,
	ToDoFormFinished,
	ToDoFormInfo,
	ToDoSearchBar,
	ToDoSearchMobile,
	ToDoFormRedirectDomain
} from "../components";
import {useDevice} from "~/hooks";
import debounce from "lodash/debounce";
import ToDoFormAddMail from "../components/Forms/ToDoFormAddMail";

function ServiceToDo() {

	const {isMobile} = useDevice();

	const dispatch      = useDispatch();

	const items         = useSelector(serviceToDoItemsSelector);

	const loading       = useSelector(serviceToDoLoadingSelector);

	const error         = useSelector(serviceToDoErrorSelector);

	const pagination    = useSelector(serviceToDoPaginationSelector);

	const filter        = useSelector(serviceToDoFilterSelector);

	const [itemEdit, setItemEdit] = useState([]);

	const [mailHostResult, setMailHostResult] = useState([]);

	//Model
	const [openModal, setOpenModal] = useState({
		status     : false,
		domain 	   : false,
		redirect   : false,
		finished   : false,
		info       : false,
		mail       : false,
		mailResult : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	//Load data
	useEffect(() => {
		handleLoading()
	}, [filter]);

	//Show Error
	if (error)
	{
		notification.error({message: 'Lỗi', description: error});
	}

	const handleLoading = () =>
	{
		dispatch(serviceToDoActions.fetchData(filter));
	}

	//Thêm yêu cầu
	const handleToDoDomainAdd = async (data) =>
	{
		let [error, response] = await handleRequest(serviceToDoApi.addDomain(data));
		let message = apiError(`Thêm yêu cầu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Thêm yêu cầu thành công`});
			dispatch(serviceToDoActions.add(response.data));
			handleModalClose('domain')
		}
	}

	const handleToDoDomainRedirect = async (data) =>
	{
		let [error, response] = await handleRequest(serviceToDoApi.addRedirectDomain(data));
		let message = apiError(`Thêm yêu cầu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Thêm yêu cầu thành công`});
			dispatch(serviceToDoActions.add(response.data));
			handleModalClose('redirect')
		}
	}

	const handleToDoHostMail = async (data) =>
	{
		let [error, response] = await handleRequest(serviceToDoApi.addHostMail(data));
		let message = apiError(`Thêm yêu cầu thất bại`, error, response);
		if(!message)
		{
			notification.success({message: 'Thành công', description: `Thêm yêu cầu thành công`});
			dispatch(serviceToDoActions.add(response.data));
			handleModalClose('mail')
		}
	}

	const handleStatus = async (item, status) => {

		if (!item?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu dịch vụ'});
			return;
		}

		let [error, response] = await handleRequest(serviceToDoApi.status({
			status: status,
			id : item.id
		}));

		let message = apiError(`Cập nhật trạng thái yêu cầu thất bại`, error, response);

		if(!message)
		{
			notification.success({message: 'Thành công', description: `Cập nhật trạng thái yêu cầu thành công`});
			let newItem = JSON.parse(JSON.stringify(item));
			newItem.status          = response.data.status;
			dispatch(serviceToDoActions.update(newItem));
		}
	}

	const handleFinished = async (item, status, server = true) => {
		if (!item?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin yêu cầu dịch vụ'});
			return;
		}
		let [error, response] = await handleRequest(serviceToDoApi.finished({
			status: status,
			id : item.id,
			server
		}));
		let message = apiError(`Cập nhật trạng thái yêu cầu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Cập nhật trạng thái yêu cầu thành công`});
			let newItem = JSON.parse(JSON.stringify(item));
			newItem.userActionId    = response.data.userActionId;
			newItem.timeAction      = response.data.timeAction;
			newItem.userAction      = response.data.userAction;
			newItem.finished        = response.data.finished;
			dispatch(serviceToDoActions.update(newItem));
			handleModalClose('finished');
			if(response.data?.mailHost && response.data.mailHost.length > 0) {
				setMailHostResult(response.data.mailHost);
				handleModalOpen('mailResult');
			}
		}
	}

	//Search
	const SearchBar = (isMobile) ? ToDoSearchMobile : ToDoSearchBar;

	const handlePaginationChange = (page) => {
		dispatch(serviceToDoActions.setFilter({...filter, page }));
	}
	const handleSearchChange = (newFilter) => {
		dispatch(serviceToDoActions.setFilterWithDebounce(newFilter));
	};

	const debouncedSearchChange = debounce(handleSearchChange, 1000);

	const handleFilterChange = (key, value, reset = false) => {
		let newFilter = {
			...filter,
			page: 1,
		};
		if(reset) {
			newFilter.keyword = '';
		}
		newFilter = {
			...newFilter,
			[key]: value,
			page: 1
		};
		dispatch(serviceToDoActions.setFilter(newFilter));
	};

	return (
		<Fragment>
			<ActionBar title={'Công Việc'}>
				<div className="d-flex gap-1 align-items-center">
					<Tippy interactive placement="bottom" offset={[-40, 10]} arrow={true}
						render={() => (
							<PopperWrapper className="action-wrapper" style={{minWidth: '220px', }}>
								<Button key="upgrade" leftIcon={Icon.upload} onClick={() => handleModalOpen('domain')}>Thêm tên miền</Button>
								<Button key="upgrade" leftIcon={Icon.upload} onClick={() => handleModalOpen('redirect')}>Chuyển hướng tên miền</Button>
								<Button key="upgrade" leftIcon={Icon.mail} onClick={() => handleModalOpen('mail')}>Tạo host mail</Button>
							</PopperWrapper>
						)}
					>
						<div><Button outline leftIcon={Icon.plusCircle} onClick={() => handleModalOpen('add')}>{!isMobile && 'Thêm mới'}</Button></div>
					</Tippy>
					<Button outline small onClick={handleLoading} style={{fontSize:'20px'}}>{Icon.reload}</Button>
				</div>
			</ActionBar>
			<SearchBar filter={filter} onChange={handleFilterChange} onSearchChange={debouncedSearchChange} />
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					{items && <ServiceToDoTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						openModal={handleModalOpen}
						handleStatus={handleStatus}
						handleFinished={handleFinished}
						setItemEdit={setItemEdit}
					/>}
				</div>
				{
					(openModal.domain) && <Modal title="Cập nhật thông tin" visible={openModal.domain} onCancel={() => handleModalClose('domain')}>
						<ToDoFormAddDomain onHandleSubmit={handleToDoDomainAdd} />
					</Modal>
				}
				{
					(openModal.redirect) && <Modal title="Chuyển hướng tên miền" visible={openModal.redirect} onCancel={() => handleModalClose('redirect')}>
						<ToDoFormRedirectDomain onHandleSubmit={handleToDoDomainRedirect} />
					</Modal>
				}
				{
					(openModal.mail) && <Modal title="Tạo host mail" visible={openModal.mail} onCancel={() => handleModalClose('mail')}>
						<ToDoFormAddMail onHandleSubmit={handleToDoHostMail} />
					</Modal>
				}
				{
					(openModal.finished) && <Modal title="Xác nhận" visible={openModal.finished} onCancel={() => handleModalClose('finished')}>
						<ToDoFormFinished item={itemEdit} onHandleSubmit={handleFinished} />
					</Modal>
				}
				{
					(openModal.info && itemEdit) && <Modal title="Xác nhận" visible={openModal.info} onCancel={() => handleModalClose('info')}>
						<ToDoFormInfo item={itemEdit} />
					</Modal>
				}
				{
					(openModal.mailResult) && <Modal title="Danh sách mail đã tạo" visible={openModal.mailResult} onCancel={() => handleModalClose('mailResult')}>
						<div className="mail-host-result">
							<p style={{marginBottom: '12px', fontWeight: 500}}>Tạo mail thành công! Dưới đây là danh sách thông tin tài khoản:</p>
							<table style={{width: '100%', borderCollapse: 'collapse'}}>
								<thead>
									<tr style={{background: '#f5f5f5'}}>
										<th style={{padding: '8px 12px', border: '1px solid #e0e0e0', textAlign: 'left'}}>Email</th>
										<th style={{padding: '8px 12px', border: '1px solid #e0e0e0', textAlign: 'left'}}>Mật khẩu</th>
									</tr>
								</thead>
								<tbody>
									{mailHostResult.map((item, index) => (
										<tr key={index} style={{background: index % 2 === 0 ? '#fff' : '#fafafa'}}>
											<td style={{padding: '8px 12px', border: '1px solid #e0e0e0'}}>{item.mail}</td>
											<td style={{padding: '8px 12px', border: '1px solid #e0e0e0'}}>{item.password}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</Modal>
				}
			</div>
		</Fragment>
	)
}
export default ServiceToDo;